import { Navigate } from 'react-router';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FOOTBALL_MARKET_NEW_SEASON } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { MarketHomePage } from '#src/components/market-home/MarketHomePage/index.tsx';

const MarketShop = () => {
  const { sport } = useSportContext();
  const {
    flags: { use2027LaunchPage = false },
  } = useFeatureFlags();

  if (use2027LaunchPage && sport === Sport.FOOTBALL) {
    return <Navigate to={FOOTBALL_MARKET_NEW_SEASON} replace />;
  }

  return <MarketHomePage sport={sport} />;
};

export default MarketShop;
